module.exports = __webpack_public_path__ + "static/media/Rohit Nagar.430e2ac6.png";